/**
 * 
 * Text Field
 * 
 */

import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Label, Input, FormGroup, Button } from 'reactstrap'


function ChooseOptionField(props) {
    const {  onChange, isInvalid ,value} = props
    
    const [list, SetList] = useState(value&& value.length!='0'?value:[{  option: ""}])
    const handelListAdd = () => {
        SetList([...list, {  option: "" }])
    }
    const handelRemove = (index) => {
        const data = [...list]
        data.splice(index, 1)
        SetList(data)
    }
    const handleOnChange = (e, index) => {
        const { name, value } = e.target
        const data = [...list]
        data[index][name] = value
        SetList(data)
    }
    return (
        <React.Fragment >

            {list.map((singleInput, index) => {
                return [
                    <>
                        <div style={{display:"inline-flex"}} className="w-50">
                            <FormGroup className='no-margin ' style={{width:"84%"}}>
                                <Label className='' htmlFor={'option' + index}>
                                    Option {parseInt(index)+1}
                                </Label>

                                <Input
                                    key={'option' }
                                    type="text"
                                    className="form-control mr-2"
                                    name={'option'}
                                    value={singleInput.option}
                                    onChange={(e) => {handleOnChange(e, index)
                                        onChange({target: { value: list}})
                                    }}
                                    id={'option' }
                                    disabled={false}
                                    placeholder='Enter option'
                                    invalid={isInvalid ? true : false}
                                />
                            </FormGroup>
                            {list.length > 1 && <Button className='btn-danger text-center'  type="button"  
                                style={{width:"18px",height: "20px" ,margin:"35px 5px",  padding: "0px", borderRadius: "100%"}}  
                                onClick={() => handelRemove(index)}>-</Button>}
                                {list.length===index+1 && <Button className={list.length>5?'d-none':'btn-success '} type="button" onChange={onChange} 
                                value={list} style={{width:"18px",height: "20px",margin:"35px 5px",padding: "0px",borderRadius: "100%"}} 
                                onClick={handelListAdd}>+</Button>}
                            
                        </div>

                    </>

                ]
            }
            )

            }
            {/* </FormGroup> */}
        </React.Fragment>
    )
}

ChooseOptionField.propTypes = {
    t: PropTypes.any,
    // label: PropTypes.s/tring,
    // value: PropTypes.any,
    // name: PropTypes.string,
    onChange: PropTypes.func,
    // placeholder: PropTypes.string,
    isInvalid: PropTypes.any,
    // required: PropTypes.bool,
    // style: PropTypes.object,
    // disabled: PropTypes.any,
    // labelClass: PropTypes.any,
    value: PropTypes.any,
}

export default ChooseOptionField